export default __webpack_public_path__ + "static/media/IN-course certificate.1ca85f35.png";